/**
 * Configuration constants for LooperC web app
 */

// Qdrant query limits
export const QUERY_LIMITS = {
    GENRES: 10000,      // Max genres to fetch
    ALBUMS: 10000,      // Max albums to fetch per genre
    SAMPLES: 1000,      // Max samples to fetch per album
    AUDIO_FILES: 100     // Max audio files to fetch
};

// Collection names
export const COLLECTIONS = {
    METADATA: 'librosa_min',
    AUDIO: 'librosa_audio'
};

// Backend URLs
// PROD: use relative /api path — routed through Cloudflare Pages Functions proxy
// (bypasses Spanish ISP LaLiga blocks on *.workers.dev IP ranges)
export const BACKEND_URL = import.meta.env.PROD
    ? '/api/qdrant'
    : 'http://localhost:8787/qdrant';

// Upload constants (keep in sync with worker tier limits)
export const FREE_MAX_UPLOAD_FILES = 40;
export const PRO_MAX_UPLOAD_FILES = 60;
export const MAX_FILE_SIZE_MB = 5;

// Style Groups - curated genre collections
// Keys are display group names; values are atomic genre strings used by the factory.
export const STYLE_GROUPS: Record<string, string[]> = {
    'Organic':   ['jazz', 'blues', 'boggie', 'brushes', 'country'],
    'Groove':    ['funk', 'reggae'],
    'Rock':      ['rock', 'garage', 'upbeat', 'pop', 'indie'],
    'Beat':      ['hiphop', 'edm', 'house', 'techno', 'dance', 'trap', 'synth'],
};
